export const errorRoutes = [
    {
        path: '/access',
        name: 'Access',
        component: () => import('@/pages/Access.vue'),
    },
    {
        path: '/error',
        name: 'Error',
        component: () => import('@/pages/Error.vue'),
    },
    {
        path: '/404/:resource',
        name: 'NotFound',
        props: true,
        component: () => import('@/pages/NotFound.vue'),
    },
    {
        path: '/404',
        name: 'NotFoundDefault',
        props: {
            resource: 'The page you are requesting for does not exist',
        },
        component: () => import('@/pages/NotFound.vue'),
    },
    {
        path: '/:resource(.*)',
        redirect: { name: 'NotFound' },
    },
];
